export default "__VITE_ASSET__3027bf5b__"